import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import { getCreatedAtForHistoryPopover } from '../../utils/dateUtils';

function DailyOSPBookingsHistory({ bookingDeltasHistory }) {
    const { t } = useTranslation();

    return (
        <>
            <Typography variant="h5" style={{ textAling: 'center', marginBottom: '1em' }}>
                {t('field.changes')}
            </Typography>

            {bookingDeltasHistory &&
                bookingDeltasHistory.map((bookingDelta) => (
                    <div key={bookingDelta.id}>
                        <Typography variant="subtitle1">
                            <span className="notranslate" style={{ color: 'var(--grey)', float: 'left' }}>
                                {getCreatedAtForHistoryPopover(bookingDelta.createdAt)}:{' '}
                            </span>
                            <span style={{ color: 'var(--primary)', float: 'right' }}>{bookingDelta.value}</span>
                        </Typography>
                    </div>
                ))}
        </>
    );
}

export default DailyOSPBookingsHistory;
